// extracted by mini-css-extract-plugin
module.exports = {"scrollContainer":"HistoryEventContainer_scrollContainer_IWqgy"};